import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { reduxForm, propTypes, change, untouch } from 'redux-form';
import { SAVE_ACCOUNT_FORM } from '../redux/modules/form';
import { NewAccountFields } from '../components/NewAccountForm';
import saveAccountValidation from './validation/saveAccountValidation';
import { ensureBankNameUnique } from '../utils/validation';
import { newAccountFormTestDataIfRequested } from '../utils/testData';
import { objectPropHasChanged } from '../utils/object';
import { stateFromAbbreviation } from '../constants/general';
import { ACCOUNT_TYPE_OPTIONS } from '../constants/payment';

function loadDealerInfo({ user, dispatch }) {
  if (!_.isNil(user)) {
    // Auto-fill address from user (dealership) profile
    const { dealerInfo } = user;
    dispatch(change(SAVE_ACCOUNT_FORM, 'companyName', _.get(dealerInfo, 'dealerName')));
    dispatch(change(SAVE_ACCOUNT_FORM, 'address', _.get(dealerInfo, 'dealerAddress')));
    dispatch(change(SAVE_ACCOUNT_FORM, 'city', _.get(dealerInfo, 'dealerCity')));
    dispatch(
      change(SAVE_ACCOUNT_FORM, 'state', stateFromAbbreviation(_.get(dealerInfo, 'dealerState'))),
    );
    dispatch(change(SAVE_ACCOUNT_FORM, 'zipCode', _.get(dealerInfo, 'dealerZip')));
    dispatch(change(SAVE_ACCOUNT_FORM, 'accountType', ACCOUNT_TYPE_OPTIONS.CHECKING));
  }
}

export class SaveAccountForm extends Component {
  static propTypes = {
    ...propTypes,
    user: PropTypes.object.isRequired,
    onChangeRoutingNumber: PropTypes.func.isRequired,
    onZipCodeChange: PropTypes.func.isRequired,
    bankDetails: PropTypes.object,
    disableSubmit: PropTypes.bool,
    zipCode: PropTypes.array,
  };

  static defaultProps = {
    bankDetails: null,
    disableSubmit: false,
    zipCode: null,
  };

  componentDidMount = () => {
    const { user, dispatch } = this.props;
    loadDealerInfo({
      user,
      dispatch,
    });
  };

  componentWillReceiveProps = (nextProps) => {
    const { dispatch, bankDetails } = nextProps;
    // Auto-fill bank name from routing number service
    if (objectPropHasChanged(bankDetails, nextProps.bankDetails)) {
      dispatch(change(SAVE_ACCOUNT_FORM, 'bankName', _.get(nextProps.bankDetails, 'name')));
      dispatch(untouch(SAVE_ACCOUNT_FORM, 'bankName'));
    }
    if (objectPropHasChanged(this.props.zipCode, nextProps.zipCode)) {
      dispatch(change(SAVE_ACCOUNT_FORM, 'city', _.get(nextProps.zipCode[0], 'city')));
      dispatch(
        change(
          SAVE_ACCOUNT_FORM,
          'state',
          stateFromAbbreviation(_.get(nextProps.zipCode[0], 'state')),
        ),
      );
    }
  };

  render() {
    const {
      user,
      bankDetails,
      disableSubmit,
      handleSubmit,
      onChangeRoutingNumber,
      onZipCodeChange,
      zipCode,
    } = this.props;
    return (
      <form className="form-horizontal" onSubmit={handleSubmit}>
        <NewAccountFields
          title="Save billing details for future payments"
          bankDetails={bankDetails}
          zipCode={zipCode}
          bankNameValidate={_.partial(ensureBankNameUnique, user)}
          onChangeRoutingNumber={onChangeRoutingNumber}
          onZipCodeChange={onZipCodeChange}
        />
        <div className="row">
          <div className="col-md-3 col-xs-12">
            <button className="btn btn-primary btn-block" type="submit" disabled={disableSubmit}>
              <i className="fa fa-save" /> Save Account
            </button>
          </div>
        </div>
      </form>
    );
  }
}

export default reduxForm({
  form: SAVE_ACCOUNT_FORM,
  validate: saveAccountValidation,
  initialValues: newAccountFormTestDataIfRequested(),
})(SaveAccountForm);
